import __request__ from 'routing/request';
/**
 * Execute an Event Procedure Step action
 */
export function handleEventProcedureAction(stepId: string, eventId?: string): Promise<unknown> {
    return __request__('GET', '/plugins/org.graylog.plugins.securityapp/event_procedure_actions', null, { 'stepId': stepId, 'eventId': eventId }, {
        'Accept': ['application/json']
    });
}
